import { Button, Grid } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const Step = ({ step, totalSteps, content, next, prev, onClose, handleEmergencyClose }) => {
  const {
    css,
    classes,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  
  if(!content?.length){
    handleEmergencyClose();
  } 

  return (
    <>
      <Grid container xs={12}  className={classes.contentContainer}>
        {content.length > 0 ? content : 'Chargement du contenu...'}
      </Grid>

      {/* BOUTONS */}

        <div className={classes.buttonContainer}>
          {step === 1 && (
            <Grid container spacing={2}>
              <Grid
                className={css({ textAlign: 'center', marginTop: spacing(4) })}
                item
                xs
              >
                <Button
                  className={css({ borderRadius: 20 })}
                  color="primary"
                  fullWidth
                  disabled={content.length === 0}
                  onClick={next}
                  type="submit"
                  variant="contained"
                >
                  Suivant
                </Button>
              </Grid>
            </Grid>
          )}
          {step > 1 && step < totalSteps && (
            <Grid container spacing={2}>
              <Grid item xs className={classes.button}>
                <Button
                  className={css({ borderRadius: 20 })}
                  color="primary"
                  fullWidth
                  disabled={content.length === 0}
                  onClick={prev}
                  variant="outlined"
                >
                  Retour
                </Button>
              </Grid>
              <Grid item xs className={classes.button}>
                <Button
                  className={css({ borderRadius: 20 })}
                  color="primary"
                  fullWidth
                  disabled={content.length === 0}
                  onClick={next}
                  type="submit"
                  variant="contained"
                >
                  Suivant
                </Button>
              </Grid>
            </Grid>
            )}
            {step === totalSteps && (
            <Grid container spacing={2}>
              <Grid item xs className={classes.button}>
                <Button
                  className={css({ borderRadius: 20 })}
                  color="primary"
                  fullWidth
                  disabled={content.length === 0}
                  onClick={prev}
                  variant="outlined"
                >
                  Retour
                </Button>
              </Grid>
              <Grid item xs className={classes.button}>
                  <Button
                  className={css({ borderRadius: 20 })}
                  color="primary"
                  fullWidth
                  disabled={content.length === 0}
                  type="submit"
                  variant="contained"
                  onClick={onClose}
                  >
                  Terminer
                  </Button>
              </Grid>
            </Grid>
          )}
        </div>
    </>
  );
};

const styles = ({ spacing }) => ({
  image: {
    width: "100%",
    height: '354px',
  },
  h2: {
    fontSize: "20px",
    fontWeight: 'bold',
    textAlign: 'center',
    margin: spacing(2, 0, 0, 0),
    color: '#0060F9',
  },
  text: {
    fontSize: "18px",
    textAlign: 'center',
    color: '#152652',
  },
  step: {
    fontSize: "18px",
    textAlign: 'center',
    margin: spacing(2),
    color: '#152652',
  },
  bold: {
    fontWeight: 600,
  },
  italic: {
    fontStyle: 'italic',
  },
  strikethrough: {
    textDecoration: 'line-through',
  },
  underline: {
    textDecoration: 'underline',
  },
  contentContainer: {
    justifyContent: 'center',
    marginBottom: '70px',
  },
  buttonContainer: {
    position: 'absolute',
    width: '92%',
    bottom: '0%',
    paddingBottom: '16px',
    backgroundColor: 'white',
  },
  button: {
    textAlign: 'center',
    marginTop: spacing(2),
  }
});

Step.propTypes = {
  data: PropTypes.object,
  next: PropTypes.func,
  prev: PropTypes.func,
  onClose: PropTypes.func,
};

export default Step;